import { motion } from "framer-motion";
import { ChevronRight } from "lucide-react";

export type Props = {
  onClick?: () => void;
  disabled?: boolean;
  icon: React.ReactNode;
  title: React.ReactNode;
  subtitle?: React.ReactNode;

  hasMoreOptions?: boolean;
};

export function ButtonWithIconSubtitleAndAccessory({
  onClick,
  disabled,
  icon,
  title,
  subtitle,
  hasMoreOptions,
}: Props) {
  return (
    <motion.button
      whileHover="hover"
      initial="rest"
      animate="rest"
      className={`mt-1 flex gap-2 items-center bg-[--color-background-secondary] rounded-md p-2 w-full group disabled:pointer-events-none ${onClick ? "cursor-pointer" : "cursor-default"}`}
      onClick={onClick ? () => onClick() : undefined}
      disabled={disabled}
    >
      <div>{icon}</div>
      <div className="flex-1 text-start">
        <div className="text-[--color-text-primary]">{title}</div>
        {subtitle ? (
          <div className="text-xs text-[--color-text-secondary] truncate">
            {subtitle}
          </div>
        ) : null}
      </div>

      {hasMoreOptions ? (
        <motion.div
          className="flex items-center justify-end transition-colors group-hover:text-blue-500 text-[--color-text-primary]"
          variants={{
            rest: { translateX: -2 },
            hover: { translateX: 0 },
          }}
        >
          <ChevronRight className="h-5 w-5" />
        </motion.div>
      ) : null}
    </motion.button>
  );
}
